




















































import { Component, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { ReserveRankListTable } from '@/components/organisms/ReserveRankListTable'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { AlertMessage, ErrorMessage, Reserve, reserveApi } from '@/api'
import { alertStore, modalErrorStore } from '@/store'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { cloneDeep, isEqual } from 'lodash'

@Component({
  components: {
    ReserveRankListTable,
    ModalFooter
  }
})
export default class ModalReserveRankEdit extends ModalComponentBaseVue {
  dialog: boolean = false

  tableBodyHeight: number = 0

  bibliographyId: number = 0

  reserves: Reserve[] = []

  inputReserves: Reserve[] = []

  @Watch('dialog')
  initialize() {
    if (this.dialog) return this.$nextTick(this.calculateTableHeight)

    this.reserves = []
    this.bibliographyId = 0
    this.tableBodyHeight = 0
  }

  @Watch('dialog')
  onShowChanged(val: boolean) {
    val ? this.opened() : this.closed()
  }

  @Watch('reserves', { immediate: true, deep: true })
  onChangeItem() {
    this.inputReserves = cloneDeep(this.reserves)
  }

  mounted() {
    window.addEventListener('resize', this.onResize)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }

  open(bibliographyId: number) {
    this.bibliographyId = bibliographyId
    this.getReserves()
    this.dialog = true
  }

  close() {
    this.dialog = false
  }

  calculateTableHeight() {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase() / 2
    })
  }

  onClickPrint() {
    const element = document.getElementById('modal-reserve-rank-edit')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onClickOk() {
    if (!isEqual(this.reserves, this.inputReserves)) {
      this.updateReserveRank()
    }
    this.close()
  }

  onResize() {
    this.calculateTableHeight()
  }

  async getReserves() {
    this.$eventBus.emit(PAGE_LOADING_START)
    try {
      this.reserves = await reserveApi.getReserves({
        bibliographyRealId: this.bibliographyId
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async updateReserveRank() {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await reserveApi.updateReserveRank({
        bibliographyId: this.bibliographyId,
        reserves: this.inputReserves.map(item => {
          return {
            id: item.id,
            revision: item.revision
          }
        })
      })

      this.$emit('ok')
      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  opened() {}

  closed() {
    this.tableBodyHeight = 0
    this.reserves = []
    this.bibliographyId = 0
  }
}
